export function extractErrorMessage(
  error: unknown,
  fallback: string = 'Something went wrong. Please try again.'
): string {

  if (!error) return fallback;

  const err = error as {
    error?: {
      message?: string;
    } | string;
    message?: string;
  };

  // Backend structured error: { error: { message: string } }
  if (
    typeof err.error === 'object' &&
    err.error !== null &&
    'message' in err.error &&
    typeof err.error.message === 'string'
  ) {
    return err.error.message;
  }

  // Backend string error: { error: "message" }
  if (typeof err.error === 'string') {
    return err.error;
  }

  // Direct message
  if (typeof err.message === 'string') {
    return err.message;
  }

  // Last resort
  return fallback;
}